<template>
  <v-menu
    ref="menu"
    :close-on-content-click="false"
    v-model="menu"
    :nudge-right="40"
    lazy
    transition="scale-transition"
    offset-y
    full-width
    max-width="290px"
    min-width="290px"
    :disabled="isDisabled"
  >
    <v-text-field
      readonly
      slot="activator"
      :value="value"
      :label="label"
      :prepend-icon="showIcon && !noClear ? 'access_time' : null"
    />
    <vue-timepicker>
      <v-spacer></v-spacer>
    </vue-timepicker>
  </v-menu>
</template>

<script>
import moment from "moment";
import VueTimepicker from 'vue2-timepicker/dist/VueTimepicker.common.js';

export default {
  name: "timePicker",
  components: {  VueTimepicker },
  props: ["value", "label", "showIcon", "disabled", "noClear", "min", "max"],
  data: () => ({
    dateParts: {
      date: null,
      time: null
    },
    formattedTime: null,
    menu: false
  }),
  watch: {
    value: {
      handler: function(val) {
        this.formattedTime = val;
        if (this.formattedTime) {
          this.dateParts.date = moment(val).format("YYYY-MM-DD");
          this.dateParts.time = this.formattedTime;
        }
      }
    }
  },
  methods: {
    selectTime($event) {
      const assemblyDate = moment(
        `${this.dateParts.date}T${$event}:00.000`
      ).toISOString();
      this.$emit("input", assemblyDate);
    }
  },
  computed: {
    isDisabled() {
      return typeof this.disabled === "undefined" ? false : this.disabled;
    }
  }
};
</script>
